const BaseModule = require('../../90_utils/base/BaseModule');

class BottomGoop extends BaseModule {

	constructor(el, params) {

		super(el);

		this.gradientTopColor = this.checkVal(this.$el.data('gradient-start-color'), '#25c4f6');
		this.gradientBottomColor = this.checkVal(this.$el.data('gradient-end-color'), '#f6379a');

		this.$shape;
		this.$gradient;
		this.$gradientStops;
		this.$goopPath;
		this.$buttonInner;
		this.$window = $(window);

		this.caption;

		this.isVideo;
		this.isLastPage = false;
		this.isPageLoaded = false;
		this.isTransitionLocked = false;
		this.isOverFooter = false;
		this.isSiteLoaded = false;
		this.isModalOpen = false;

		// init shapes

		this.$innerContent = this.$el.find('.inner-content');
		this.$shape = this.$el.find('.svg');
		this.$gradient = this.$shape.find('#gradient');
		this.$gradientStops = this.$gradient.find('stop');
		this.$goopPath = this.$shape.find('#bulge-path');

		this.rectData = 'M427.5,78C280.5,75,326,76,269,76s-11.6-1-158.5,2H-1284v8H1822V78H427.5Z';

		if(isNaN(window.SETTINGS.vars.svgIndex)){ window.SETTINGS.vars.svgIndex = 0; }
		else { window.SETTINGS.vars.svgIndex++; }

		let gradientId = window.SETTINGS.vars.svgIndex;
		this.$gradient.attr('id', 'gradient' + gradientId);
		this.$shape.find('path').attr('fill', 'url(#gradient' + gradientId + ')');
	}

	// basemodule methods

	_domReady(){ }

	_addListeners(){

		// let options = {preventDefault:true};
		// this.$el.find('.continue').hammer(options).on('tap', $.proxy(this._onButtonClick, this));

		this.$window.on('scroll', $.proxy(this._onScroll, this));
		this.$el.find('.goop-button').on('click', $.proxy(this._onButtonClick, this));
		this.$el.find('.continue').on('click', $.proxy(this._onButtonClick, this));

		window.vent.on('modalOpen', this._onModalOpen, this);
		window.vent.on('modalClose', this._onModalClose, this);
		window.vent.on('siteLoadComplete', this._onSiteLoadComplete, this);
		window.vent.on('heroChangeRoute', this._onHeroChangeRoute, this);
		window.vent.on('pageChangeStart', this._onPageChangeStart, this);
		window.vent.on('pageChangeComplete', this._onPageChangeComplete, this);
	}

	_removeListeners(){

		this.$window.off('scroll', $.proxy(this._onScroll, this));
		this.$el.find('.goop-button').off('click', $.proxy(this._onButtonClick, this));
		this.$el.find('.continue').off('click', $.proxy(this._onButtonClick, this));

		window.vent.off('modalOpen', this._onModalOpen, this);
		window.vent.off('modalClose', this._onModalClose, this);
		window.vent.off('siteLoadComplete', this._onSiteLoadComplete, this);
		window.vent.off('heroChangeRoute', this._onHeroChangeRoute, this);
		window.vent.off('pageChangeStart', this._onPageChangeStart, this);
		window.vent.off('pageChangeComplete', this._onPageChangeComplete, this);
	}

	// event methods

	_onButtonClick(e){

		e.preventDefault();

		if(this.isPageLoaded){

			if(this.isOverFooter){
				let href = $('.footer-hero .centered-quote a.title-link').attr('data-href');
				window.vent.trigger('heroChangeRoute', {route: href});
				window.vent.trigger('changeRoute', {route: href});
			}
			else {

				if($('body').hasClass('page-action') && window.SETTINGS.breakpoint.minWidth('screen-medium')){
					window.vent.trigger('triggerScrollStep', {delta:1});
				}
				else {
					window.vent.trigger('scrollTo', {scrollTop:$(window).innerHeight()});
				}
			}
		}
	}

	_onScroll(){

		let scrollTop = this.$window.scrollTop();
		let shouldShow = true;

		if(this.isPageLoaded && !this.isTransitionLocked && !this.isModalOpen){

			let docHeight = window.SETTINGS.coords.getDocHeight();
			let winHeight = window.SETTINGS.coords.winHeight;
			let edgeLeeway = 100;

			// conditions to hide

			if(scrollTop >= docHeight - winHeight - edgeLeeway){

				if(!this.isLastPage){
					shouldShow = true;
					this.$el.addClass('is-over-footer');
					this.isOverFooter = true;
				}
				else {
					shouldShow = false;
					this.$el.removeClass('is-over-footer');
					this.isOverFooter = false;
				}
			}

			if(scrollTop < docHeight - winHeight - edgeLeeway && scrollTop > edgeLeeway){

				shouldShow = false;

				this.$el.removeClass('is-over-footer');
				this.isOverFooter = false;

				this.caption = 'Read More';
				this.isVideo = false;
			}

			if(shouldShow){

				if(!this.$innerContent.hasClass('is-showing')){

					if(this.isOverFooter){ this._redraw(); }
					else { this._checkPage(); }

					this.$innerContent.addClass('is-showing');

					let d = this.$goopPath.attr('d');

					TweenMax.set(this.$buttonInner, { opacity: 0 });
					this.$goopPath.attr('d', this.rectData);

					if(window.SETTINGS.breakpoint.minWidth('screen-medium')){

						let delay = 0.2;

						TweenMax.to(this.$goopPath, 0.48, {
							morphSVG: d,
							delay: delay,
							ease: 'progressSlide'
						});

						TweenMax.to(this.$buttonInner, 0.2, {
							opacity: 1,
							clearProps: 'opacity',
							ease: 'fade',
							delay: delay
						});
					}
				}
			}
			else {

				if(this.$innerContent.hasClass('is-showing')){

					if(window.SETTINGS.breakpoint.minWidth('screen-medium')){

						TweenMax.to(this.$goopPath, 0.4, {
							morphSVG: this.rectData,
							delay: 0.2,
							ease: 'progressSlide'
						});

						TweenMax.to(this.$buttonInner, 0.1, {
							opacity: 0,
							ease: 'fade'
						});
					}

					TweenMax.delayedCall(0.1, ()=>{
						this.$innerContent.removeClass('is-showing');
					});
				}
			}
		}
	}

	_onModalOpen(){
		this.isModalOpen = true;
	}

	_onModalClose(){
		this.isModalOpen = false;
	}

	_onHeroChangeRoute(){
		this.isTransitionLocked = true;
		this.$innerContent.removeClass('is-showing');
	}

	_onPageChangeStart(){

		this.isPageLoaded = false;

		if(!this.isTransitionLocked){
			this.$innerContent.removeClass('is-showing');
		}
	}

	_onPageChangeComplete(){

		if(this.isSiteLoaded){

			if(this.isTransitionLocked){
				window.setTimeout(() => {
					this.isTransitionLocked = false;
				}, 500);
			}
			else {
				this.isTransitionLocked = false;
			}

			this.isPageLoaded = true;
			this._checkPage();
			this._onScroll();
		}
	}

	_onSiteLoadComplete(){

		this.isSiteLoaded = true;

		// show video

		// this._onPageChangeComplete();
	}

	// change goop based on page

	_checkPage(){

		let routeObj = window.SETTINGS.router.getRouteObj();
		let pageId = routeObj.pageId;

		switch(pageId){

			case 'impact':
			this.caption = 'Our Impact';
			this.isVideo = false;
			this.gradientTopColor = '#25c4f6';
			this.gradientBottomColor = '#6643c9';
			break;

			case 'action':
			this.caption = 'Explore';
			this.isVideo = false;
			this.gradientTopColor = '#ed3b44';
			this.gradientBottomColor = '#fbdc30';
			break;

			case 'intro':
			this.caption = 'Play';
			this.isVideo = true;
			this.gradientTopColor = '#5be745';
			this.gradientBottomColor = '#25c4f6';
			break;

			case 'vision':
			this.caption = 'Our Vision';
			this.isVideo = false;
			this.gradientTopColor = '#25c4f6';
			this.gradientBottomColor = '#f6379a';
			break;
		}

		if(window.SETTINGS.router.getRouteObj().pageId === 'impact'){
			this.isLastPage = true;
		}
		else {
			this.isLastPage = false;
		}

		this._redraw();
	}

	_redraw(){

		if(this.isOverFooter){
			this.gradientTopColor = '#ffffff';
			this.gradientBottomColor = '#ffffff';
		}

		// text and icon

		this.$el.find('.goop-button-inner').removeClass('is-showing');

		if(this.isVideo){
			this.$buttonInner = this.$el.find('.goop-button-inner--video');
		}
		else {
			this.$buttonInner = this.$el.find('.goop-button-inner--scroll');
		}

		this.$buttonInner.addClass('is-showing');
		this.$buttonInner.find('.title').html(this.caption);

		// goop shape

		let scale = window.SETTINGS.breakpoint.minWidth('screen-small') ? 1 : 2.5625;
		let containerWidth = this.$el.outerWidth() * scale;
		let bulgeWidth = 538;
		let bleed = (containerWidth - bulgeWidth)/2;

		let newD = 'M427.5,77.4C280.5,74.4,326,0,269,0s-11.6,74.4-158.5,77.4C109.1,77.4,2.3,78,2.3,78L' + (0 - bleed) + ',78v8 h' + containerWidth + 'v-8l-1.5,0C536.5,78,428.9,77.4,427.5,77.4z';

		this.$gradientStops.eq(0).attr('stop-color', this.gradientTopColor);
		this.$gradientStops.eq(1).attr('stop-color', this.gradientBottomColor);
		this.$goopPath.attr('d', newD);
	}

	//

	_show(){
		this.$el.addClass('is-showing');
	}

	_hide(){
		this.$el.removeClass('is-showing');
	}

	_enable(){ }
	_disable(){ }

	_domUpdate(){ }
	_resize(){
		this._redraw();
	}
}

module.exports = BottomGoop;
